// extracted by mini-css-extract-plugin
export default {"memberNotifications":"memberNotifications__index__WXPF2"};